<mbs-alert
  class="mb-0"
  [size]="alertSize"
  [type]="alertType.warning">
  @for (sentence of sentences(); track sentence.offer.action) {
    {{ sentence.beforeKey | i18next: { count: sentence.count } }}
    @if (sentence.afterKey) {
      @for (entry of sentence.entries; track entry.buildType; let first = $first; let last = $last) {
        @let releaseNotesLink = showReleaseNotes() && entry.releaseNotesPath ? (entry.releaseNotesPath | helpLink) : null;
        <span class="text-nowrap"
          >{{ first ? '(' : ''
          }}<a
            target="_blank"
            [attr.class]="releaseNotesLink ? 'fw-semibold' : null"
            [attr.data-e2e]="elementSelectors.name.version"
            [attr.href]="releaseNotesLink"
            >v{{ entry.version }}</a
          >{{ sentence.offer.showOs ? ' ' + ('shared:forceUpdate.newVersion.forOs' | i18next: { os: (entry.osKey | i18next) }) : ''
          }}{{ last ? ')' : ',' }}</span
        >{{ last ? '' : ' ' }}
      }
      {{ sentence.afterKey | i18next: { count: sentence.count } }}
    }
    @if (canManageBuilds()) {
      <mbs-button
        customClasses="fw-semibold"
        [attr.data-e2e]="elementSelectors.name.action + '-' + sentence.offer.action"
        [disabled]="disabled()"
        [isCtrl]="true"
        [loading]="busyActions().includes(sentence.offer.action)"
        [size]="buttonSize"
        (click)="actionClick.emit(sentence.offer)">
        {{ sentence.linkKey | i18next: { count: sentence.count } }}
      </mbs-button>
      {{ sentence.suffixKey | i18next: sentence.suffixParams }}
    }
  }
</mbs-alert>
